import { IWebView } from '@common/types/element';
import { getValueBindingComponent } from '@common/utils/component';
import { isEmpty, pick } from 'lodash';
import React, { FC, useMemo } from 'react';
import { Image as RNImage, Platform, View } from 'react-native';
import { WebView } from 'react-native-webview';
import createStyles from './style';

const CusWebView: FC<IWebView> = (attributes) => {
  const styles = createStyles(attributes);
  const uri: string = useMemo(
    () => getValueBindingComponent(attributes, 'uri'),
    [attributes]
  );

  const validLink = isEmpty(uri.match(/^((http|https):\/\/)/));
  const check = validLink ? `https://${uri}` : uri;

  const expression =
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
  const regex = new RegExp(expression);
  if (!uri) return <View style={styles.container} />;

  if (!uri.match(regex)) {
    return (
      <View style={styles.container}>
        <RNImage
          source={{
            uri: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5JMgzHBTZO_V1iTlq6Fr-Lywo85GD65RMtOFU1GgUjOhsw-DoYI4V0nzG99A9wqSduZU&usqp=CAU',
          }}
          style={{
            ...pick(attributes, ['width', 'height']),
          }}
          resizeMode={'contain'}
        />
      </View>
    );
  }
  return (
    <View
      style={{
        zIndex: attributes.zIndex,
        ...(Platform.OS !== 'web' && styles.container),
      }}
    >
      <WebView
        style={styles.container}
        source={{ uri: check as any }}
        mediaPlaybackRequiresUserAction={true}
        allowsInlineMediaPlayback={true}
        contentInsetAdjustmentBehavior={'automatic'}
        nestedScrollEnabled={true}
        renderError={() => {
          return <View style={styles.errorRender} />;
        }}
      />
    </View>
  );
};

export default CusWebView;
